// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-card {
  max-width: 600px;
  margin: 2rem auto;
}

.image-card-content {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  padding: 0;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.1),
    0 1px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.image-card-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #8B4513, #D2B48C, #F5DEB3);
  border-radius: 20px 20px 0 0;
  z-index: 2;
}

.image-card-content:hover {
  transform: translateY(-5px);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.15),
    0 5px 15px rgba(0, 0, 0, 0.1);
}

.image-container {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.image-container:hover .card-image {
  transform: scale(1.05);
}


.slogan-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 450px;
  margin: 1.5rem auto 0;
  text-align: center;
}

.slogan-icon {
  font-size: 2rem;
  animation: sparkle 2s ease-in-out infinite;
}

@keyframes sparkle {
  0%, 100% { transform: scale(1) rotate(0deg); }
  50% { transform: scale(1.1) rotate(10deg); }
}

.slogan-text {
  font-family: 'Playfair Display', 'Times New Roman', serif;
  font-size: 1.5rem;
  color: #495057;
  line-height: 1.6;
  margin: 0;
  text-align: center;
  font-style: italic;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #8B4513, #A0522D);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Dark theme support */
[data-theme="dark"] .image-card-content {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .slogan-text {
  background: linear-gradient(135deg, #D2B48C, #F5DEB3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Responsive design */
@media (max-width: 768px) {
  .image-card {
    margin: 1rem auto;
    padding: 0 0.5rem;
  }
  
  .image-container {
    height: 200px;
  }
  
  .overlay-title {
    font-size: 1.2rem;
  }
  
  .overlay-text {
    font-size: 0.9rem;
  }
  
  .slogan-text {
    font-size: 1rem;
  }
  
  .slogan-container {
    margin: 1rem auto 0;
  }
}

@media (max-width: 480px) {
  .image-container {
    height: 180px;
  }
  
  .overlay-icon {
    font-size: 2rem;
  }
  
  .overlay-title {
    font-size: 1rem;
  }
  
  .slogan-text {
    font-size: 0.9rem;
  }
  
  .slogan-icon {
    font-size: 1.5rem;
  }
  
  .slogan-container {
    margin: 1rem auto 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageCard/ImageCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;EACV;;iCAE+B;EAC/B,0CAA0C;EAC1C,mCAAmC;EACnC,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B;;iCAE+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,WAAW,gCAAgC,EAAE;EAC7C,MAAM,mCAAmC,EAAE;AAC7C;;AAEA;EACE,yDAAyD;EACzD,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".image-card {\n  max-width: 600px;\n  margin: 2rem auto;\n}\n\n.image-card-content {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 20px;\n  padding: 0;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.1),\n    0 1px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.image-card-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #8B4513, #D2B48C, #F5DEB3);\n  border-radius: 20px 20px 0 0;\n  z-index: 2;\n}\n\n.image-card-content:hover {\n  transform: translateY(-5px);\n  box-shadow: \n    0 20px 40px rgba(0, 0, 0, 0.15),\n    0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.image-container {\n  position: relative;\n  width: 100%;\n  height: 300px;\n  overflow: hidden;\n  border-radius: 16px 16px 0 0;\n}\n\n.card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: all 0.3s ease;\n}\n\n.image-container:hover .card-image {\n  transform: scale(1.05);\n}\n\n\n.slogan-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  max-width: 450px;\n  margin: 1.5rem auto 0;\n  text-align: center;\n}\n\n.slogan-icon {\n  font-size: 2rem;\n  animation: sparkle 2s ease-in-out infinite;\n}\n\n@keyframes sparkle {\n  0%, 100% { transform: scale(1) rotate(0deg); }\n  50% { transform: scale(1.1) rotate(10deg); }\n}\n\n.slogan-text {\n  font-family: 'Playfair Display', 'Times New Roman', serif;\n  font-size: 1.5rem;\n  color: #495057;\n  line-height: 1.6;\n  margin: 0;\n  text-align: center;\n  font-style: italic;\n  letter-spacing: 0.5px;\n  background: linear-gradient(135deg, #8B4513, #A0522D);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .image-card-content {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .slogan-text {\n  background: linear-gradient(135deg, #D2B48C, #F5DEB3);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .image-card {\n    margin: 1rem auto;\n    padding: 0 0.5rem;\n  }\n  \n  .image-container {\n    height: 200px;\n  }\n  \n  .overlay-title {\n    font-size: 1.2rem;\n  }\n  \n  .overlay-text {\n    font-size: 0.9rem;\n  }\n  \n  .slogan-text {\n    font-size: 1rem;\n  }\n  \n  .slogan-container {\n    margin: 1rem auto 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .image-container {\n    height: 180px;\n  }\n  \n  .overlay-icon {\n    font-size: 2rem;\n  }\n  \n  .overlay-title {\n    font-size: 1rem;\n  }\n  \n  .slogan-text {\n    font-size: 0.9rem;\n  }\n  \n  .slogan-icon {\n    font-size: 1.5rem;\n  }\n  \n  .slogan-container {\n    margin: 1rem auto 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
